import { BaseModel } from './base.model';

export class City extends BaseModel{
    static fromJsonToObject(jsonData:any):City{
        return Object.assign(new City(),jsonData);
    }
}